const baseUrls = {
  local:
    process.env.NEXT_PUBLIC_RX_API_LOCAL ||
    'https://6k1tk9u18e.execute-api.us-east-1.amazonaws.com/',
  stage: 'https://yoc68k3wu5.execute-api.us-east-1.amazonaws.com/',
  prod: 'https://gc48wy60qc.execute-api.us-east-1.amazonaws.com/',
}

const getBaseUrl = (url) => {
  return `${baseUrls?.[process.env.NEXT_PUBLIC_STAGE] || baseUrls.local}${url}`
}

export const createCardWithoutUser = async (formData) => {
  try {
    const response = await fetch(getBaseUrl('rx-card-create'), {
      method: 'POST',
      body: JSON.stringify(formData),
    })
    const data = await response.json()
    if (data?.success) {
      return { data: data?.data, error: false, success: true }
    } else {
      return { erorr: true, message: error?.message || 'Something went wrong' }
    }
  } catch (error) {
    return { error: true, message: error.message || true }
  }
}

export const getDrugs = async (stext) => {
  try {
    const response = await fetch(
      getBaseUrl(`glicproxy-service-handler?reqType=searchdrug&stext=${stext}`),
      {
        method: 'POST',
      },
    )
    const data = await response.json()
    return data?.body?.[0]?.data
  } catch (error) {
    return []
  }
}

export const getDrugComponents = async (drugName) => {
  try {
    const response = await fetch(
      getBaseUrl(`glicproxy-service-handler?reqType=drugcomponents&DrugName=${drugName}`),
      {
        method: 'POST',
      },
    )
    const data = await response.json()
    return data?.body?.[0]?.data?.[0]
  } catch (error) {
    return []
  }
}

export const getPharmacies = async ({ zipcode, ndc, quantity }) => {
  try {
    const response = await fetch(
      getBaseUrl(
        `glicproxy-service-handler?reqType=searchndc&ZipCode=${zipcode}&NDC=${ndc}&Quant=${quantity}`,
      ),
      {
        method: 'POST',
      },
    )
    const data = await response.json()
    return data?.body?.[0]?.data
  } catch (error) {
    return []
  }
}

export const getPopularDrugs = async () => {
  try {
    const response = await fetch(
      getBaseUrl(`glicproxy-service-handler?reqType=populardrug`),
      {
        method: 'POST',
      },
    )
    const data = await response.json()
    return data?.body?.[0]?.data
  } catch (error) {
    return []
  }
}

export const enrollRxUser = async (body) => {
  try {
    const res = await fetch(getBaseUrl('rx-activation'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    return res
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const getRxUser = async (body) => {
  try {
    const res = await fetch(getBaseUrl('rx-lookup'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    const data = await res.json()
    return data
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const textRxCard = async (body) => {
  try {
    const res = await fetch(getBaseUrl('rx-card'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    const data = await res.json()
    return data
  } catch (err) {
    console.error(err)
    throw err
  }
}
